import {Component, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';
import {DatePipe} from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-message-quote',
  imports: [
  ],
  templateUrl: './message-quote.component.html',
  styleUrl: './message-quote.component.scss'
})
export class MessageQuoteComponent {
  @Input() message!: Message;

  // getMediaUrl(message: Message): string | undefined {
  //   if (message.mediaUrl) {
  //     return message.mediaUrl;
  //   } else if (message.attachment) {
  //     return message.attachment;
  //   } else if (message.fileId) {
  //     return message.fileId;
  //   }
  //   return undefined;
  // }

  openQuote(message: Message) {
    const url = message.mediaUrl;
    window.open(url, '_blank');
  }
}
